// extracted by mini-css-extract-plugin
export var spin = "form-state-module--spin--45408";
export var state = "form-state-module--state--dca79";
export var state__error = "form-state-module--state__error--68b0a";
export var state__flex = "form-state-module--state__flex--1f24e";
export var state__hide = "form-state-module--state__hide--aa4e0";
export var state__show = "form-state-module--state__show--96015";